<div class="wrapper" [class.has-background]="hasBackground" [formGroup]="form" role="region" aria-label="Wrapper">
	<div (click)="selectCountryCode()" class="country-code" role="button" tabindex="0">
		<div class="flag-container" role="region" aria-label="Flag container">
			<ion-img class="flag" [src]="'../../../../assets/flag/flags-country/' + flag + '.svg'" alt="Country flag"></ion-img>
		</div>
		{{ form.get('country')?.value }}
		<ion-icon class="arrow" name="caret-down-sharp"></ion-icon>
	</div>
	<ion-input lines="none" formControlName="phone" type="number" placeholder="45483543534"></ion-input>
</div>
